import axios from "axios";
import { apiDomain } from "../../store/constants";

const CalendarActivity = {
  index(payload) {
    return axios({
      url: apiDomain + "api/calendar-activity/index",
      method: "GET",
      params: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  create(payload) {
    return axios({
      url: apiDomain + "api/calendar-activity/create",
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  save(payload) {
    return axios({
      url: apiDomain + "api/calendar-activity/store",
      method: "POST",
      data: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  show(payload) {
    return axios({
      url: apiDomain + "api/calendar-activity/" + payload.id +'/show',
      method: "GET",
      params: {
        page: payload.page,
        keyword: payload.keyword,
      },
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  edit(payload) {
    return axios({
      url: apiDomain + "api/calendar-activity/" + payload.id +'/edit',
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  update(payload) {
    return axios({
      url: apiDomain + "api/calendar-activity/" + payload.id +'/update',
      method: "PUT",
      data: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  delete(id) {
    return axios({
      url: apiDomain + "api/calendar-activity/" + id +'/destroy',
      method: "DELETE",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  }
};

export default CalendarActivity;